import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import Preview from "../components/Preview.js";
import * as Yup from "yup";
import InputMask from "react-input-mask";


export default function Edit(props) {
  const {
    onHide,
    show,
    asset,
    onAssets,
    skip,
    take,
    sortField,
    orderBy,
  } = props;
  const {
    id,
    name,
    contactPerson,
    contactPersonPhoneNumber,
    contactPersonEmail,
    filePath,
  } = asset;

  const fileUrl = "https://cdn.deyerlisen.az/" + filePath;
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState(true);
  const [imageSrc, setImageSrc] = useState(fileUrl);
  useEffect(() => {
    setImageSrc(fileUrl);
  }, [fileUrl]);

  const [isError, setIsError] = useState("");

  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };

  const form = useRef(null);
  const onPutAsset = (values, resetForm, setSubmitting) => {
    const asset = new FormData(form.current);
    axios
      .put(`${process.env.REACT_APP_API_URL}asset`, asset, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onAssets(skip, take, sortField, orderBy);
        setPreview(true);
        setImageSrc("");
        setFile("");
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };




  const EditSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    contactPerson: Yup.string().required("Contact person is required"),
    phoneNumber: Yup.string().required("Phone number is required"),
    email: Yup.string().required("Email is required")
    .email("Wrong email format. E.g. jhon.doe@example.com")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    ,
  });

  const getInputClasses = (touched, errors, FieldName) => {
    if (touched[FieldName] && errors[FieldName]) {
      return true;
    }
    if (touched[FieldName] && errors[FieldName]) {
      return false;
    }

    return false;
  };



  return (
    <Modal
      onHide={onHide}
      show={show}
      size="sm"
      aria-labelledby="edit"
      className="modal-right pr-0"
    >
      {asset &&
        Object.keys(asset).length !== 0 &&
        asset.constructor === Object && (
          <Formik
            initialValues={{
              id: id,
              name: name,
              contactPerson: contactPerson,
              phoneNumber: contactPersonPhoneNumber,
              email: contactPersonEmail,
              filePath: filePath,
            }}
            validationSchema={EditSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
              onPutAsset(values, resetForm, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              handleChange,
              handleBlur,
              resetForm,
            }) => (
              <form onSubmit={handleSubmit} ref={form}>
                <Modal.Header closeButton>
                  <Modal.Title id="edit">Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-12 pl-4 pr-4">
                    <div className="row">
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {isError && (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block MuiFormLabel-root Mui-error">
                                {isError}
                              </div>
                            </div>
                          )}
                          <input
                            type="hidden"
                            id="id"
                            name="id"
                            value={values.id}
                          />
                          <TextField
                            id="name"
                            name="name"
                            label="Name"
                            placeholder="Name"
                            className="w-100"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "name")}
                          />
                        </div>
                        {touched.name && errors.name ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.name}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="contactPerson"
                            name="contactPerson"
                            label="Contact person"
                            placeholder="Contact person"
                            className="w-100"
                            value={values.contactPerson}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "contactPerson")}
                          />
                        </div>
                        {touched.contactPerson && errors.contactPerson ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.contactPerson}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {/* <TextField
                            id="phoneNumber"
                            name="phoneNumber"
                            label="Phone number"
                            placeholder="Phone number"
                            className="w-100"
                            value={values.phoneNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "phoneNumber")}
                          /> */}
                          <InputMask
                            mask="\9\94999999999"
                            value={values.phoneNumber}
                            // onChange={(e) => handleChangePhoneNumber(e)}
                            onChange={handleChange}
                            disabled={false}
                            maskChar=""
                            id="phoneNumber"
                            type="number"

                          >
                            {() =>
                              <TextField
                                label="Phone number"
                                placeholder="Phone number"
                                className="w-100"
                                name="phoneNumber"
                              // onKeyDown={handleEnter}

                              // error={getInputClasses("phone")}
                              // {...formik.getFieldProps("phone")}
                              />}
                          </InputMask>
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="email"
                            name="email"
                            label="Contact person email"
                            placeholder="Contact person email"
                            className="w-100"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "email")}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3">
                          <label htmlFor="contained-button-file">
                            <Input
                              accept="image/*"
                              id="contained-button-file"
                              type="file"
                              name="file"
                              label="File URL"
                              placeholder="File URL"
                              className="w-100"
                              onChange={imagePreview}
                              value={file}
                              hidden
                            />
                            <Button2 variant="contained" component="span">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Devices/Camera.svg"
                                )}
                                className="mr-2"
                              />
                              Change image
                            </Button2>
                          </label>
                          <Preview
                            preview={preview}
                            imageSrc={imageSrc}
                            onClick={onClick}
                          />
                        </div>
                        {touched.filePath && errors.filePath ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.filePath}
                            </div>
                          </div>
                        ) : null}
                        {isError && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block MuiFormLabel-root Mui-error">
                              {isError}
                            </div>
                          </div>
                        )}

                      </div>



                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="light"
                    onClick={() => {
                      onHide(false);
                      resetForm();
                    }}
                  >
                    Close
                  </Button>
                  <Button type="submit">Edit</Button>
                </Modal.Footer>
              </form>
            )}
          </Formik>
        )}
    </Modal>
  );
}
